import { CarouselPanel } from "plos/src/components/CarouselPanel";
import { useTranslation } from "react-i18next";
import { FixtureNews } from "./FixtureNews";
import { useClubTeamNews } from "./hooks/useClubTeamNews";

const ClubTeamNews = () => {
  const { t } = useTranslation("common");
  const { fixturesWithNews, hasEnoughNews } = useClubTeamNews();

  if (!hasEnoughNews) return null;

  return (
    <section>
      <CarouselPanel title={t("clubTeamNews.title", "Team news")}>
        {fixturesWithNews.map(({ homeTeam, awayTeam, fixtureNewsArticles }) => (
          <FixtureNews
            key={`${homeTeam.id}-${awayTeam.id}`}
            homeTeam={homeTeam}
            awayTeam={awayTeam}
            fixtureNewsArticles={fixtureNewsArticles}
          />
        ))}
      </CarouselPanel>
    </section>
  );
};

export default ClubTeamNews;
